export const getVisiblePages = (
  totalPages: number,
  page: number
): (number | string)[] => {
  const maxVisible = 10
  const pages: (number | string)[] = []

  if (totalPages <= maxVisible) {
    // When there are 10 or fewer pages, display them all.
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
  } else {
    // More than 10 pages exist – always display exactly 10 pagination items.
    const firstPage = 1
    const lastPage = totalPages

    // Case 1: Near the beginning.
    // If the current page is 6 or lower, display pages 1 to 8, then an ellipsis and the last page.
    if (page <= 6) {
      for (let i = 1; i <= 8; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(lastPage)
    }
    // Case 2: Near the end.
    // If the current page is within the last 6 pages, display the first page,
    // an ellipsis and then the final 8 pages.
    else if (page >= totalPages - 5) {
      pages.push(firstPage)
      pages.push('...')
      for (let i = totalPages - 7; i <= totalPages; i++) {
        pages.push(i)
      }
    }
    // Case 3: In the middle.
    // Display the first page, an ellipsis, a window of 6 pages centred around the current page,
    // another ellipsis and the last page.
    else {
      pages.push(firstPage)
      pages.push('...')
      // For a window of 6 pages we use two pages before the current page and three pages after.
      // This gives us a total of 6 items in the window.
      const startWindow = page - 2
      const endWindow = page + 3
      for (let i = startWindow; i <= endWindow; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(lastPage)
    }
  }
  return pages
}
